module.exports = __webpack_public_path__ + "static/noni-978069504b3ffb2eda1423ddb6735eaf.jpg";